export default "__VITE_ASSET__C2JDUH_1__"